import React from "react";
import Select from "react-select";

const GroupDropdown = (props) => {
  const {
    items = [],
    attr = "brand",
    className = "",
    onSelectView,
    selectedView = {},
    hasRollup = false,
    isSuperAdmin = false,
  } = props;

  const options = [];

  if (hasRollup) {
    options.push({
      id: null,
      name: "All",
      attr: "brand",
      label: "All",
      value: "all",
    });
  }

  items.forEach((item) => {
    options.push({
      ...item,
      attr,
      label: item.name,
      value: item.id,
    });

    if (item.stores && !isSuperAdmin) {
      item.stores.forEach((store) => {
        options.push({
          ...store,
          attr: "store",
          label: store.name,
          value: store.id,
        });
      });
    }
  });

  const selectedOption =
    options.find(
      (o) =>
        (o.id === selectedView.id || (!o.id && !selectedView.id)) &&
        o.attr === selectedView.attr,
    ) || options[0];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#14C49B",
      borderColor: "#14C49B",
      borderRadius: "0.42rem",
      minHeight: "38px",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(20, 196, 155, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#11a885",
        backgroundColor: "#11a885",
      },
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#FFFFFF",
      fontWeight: "500",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(255, 255, 255, 0.8)",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#FFFFFF",
      "&:hover": {
        color: "#FFFFFF",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.42rem",
      boxShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.15)",
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#14C49B"
        : state.isFocused
        ? "#e8f9f5"
        : "transparent",
      color: state.isSelected ? "#FFFFFF" : "#3F4254",
      paddingLeft: state.data.attr === "store" ? "2rem" : "1rem",
      fontSize: "0.9rem",
      fontWeight: state.data.attr === "brand" ? "600" : "400",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#14C49B",
      },
    }),
  };

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <span
        className="px-2 mr-2 text-center font-weight-bold"
        style={{ whiteSpace: "nowrap" }}
      >
        Filter By:
      </span>
      <div style={{ minWidth: "200px" }}>
        <Select
          options={options}
          value={selectedOption}
          onChange={(option) => onSelectView(option)}
          styles={customStyles}
          isSearchable={true}
          placeholder="Select View..."
        />
      </div>
    </div>
  );
};

export default GroupDropdown;
